import { render } from "./ConfidantPageLayout.vue?vue&type=template&id=7bbf22db"
import script from "./ConfidantPageLayout.vue?vue&type=script&lang=js"
export * from "./ConfidantPageLayout.vue?vue&type=script&lang=js"

import "./ConfidantPageLayout.vue?vue&type=style&index=0&id=7bbf22db&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__